var api = require("!../../../../style-loader@1.3.0-788d61699e458e8264b0/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../css-loader@5.2.7-2f59efcfd29cbbfca13f/node_modules/css-loader/dist/cjs.js!./slick.css");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};